import { roundToPlaces } from "../../utils/roundToPlaces.js";
import { Currency } from "../Currency.js";
import type { ExchangeRate } from "../ExchangeRatesSetting.js";

export function convertToCurrency(
	price: number,
	currency: Currency,
	targetCurrency: Currency,
	exchangeRates: ExchangeRate[],
): number {
	if (currency === targetCurrency) {
		return price;
	}
	let czk = price;
	if (currency !== Currency.CZK) {
		const exchangeRateTo = exchangeRates.find((rate) => rate.currency === currency);
		if (!exchangeRateTo) {
			throw new Error(`No exchange rate found for currency: ${currency}`);
		}
		czk = roundToPlaces(price * exchangeRateTo.exchangeRate, 2);
	}
	if (targetCurrency === Currency.CZK) {
		return czk;
	}
	const exchangeRate = exchangeRates.find((rate) => rate.currency === targetCurrency);
	if (!exchangeRate) {
		throw new Error(`No exchange rate found for currency: ${targetCurrency}`);
	}
	return roundToPlaces(czk / exchangeRate.exchangeRate, 2);
}
